<script lang="ts">
import { defineComponent, ref } from 'vue';
import { AuthStore } from 'stores/User/Auth.ts';
import { useMeta } from 'quasar';
import UserAgreements from 'components/User/Registration/UserAgreements.vue';
import BasicLink from 'components/BasicLink.vue';
import KVKKInformation from 'components/User/Registration/KVKKInformation.vue';
import KVKKAgreements from 'components/User/Registration/KVKKAgreements.vue';

const dateformat = /^(0?[1-9]|[12][0-9]|3[01])[\/.](0?[1-9]|1[012])[\/.]\d{4}$/;
export default defineComponent({
  name: 'LoginOrRegister.vue',
  components: { KVKKAgreements, KVKKInformation, BasicLink, UserAgreements },

  setup() {
    const userStore = AuthStore();

    const loginForm = ref({
      email: '',
      password: '',
      session: '',
    });

    const loginFormLoading = ref(false);

    const registerForm = ref({
      nameSurname: '',
      email: '',
      // lokasyon: {
      //   il: '',
      //   ilce: ''
      // },
      password: '',
      passwordAgain: '',
      birthday: '',
      userAgreement: false,
      gdprAgreement: false,
      kvkkInformationAgreement: false,
    });
    const birthdayFormat = ref('');

    const registerFormLoading = ref(false);

    const rules = ref({
      dateRule: (data) => data.match(dateformat) || 'Lütfen geçerli bir tarih belirtin Örn: 05.05.1993',
    });

    useMeta({
      titleTemplate: (title) => `${title} | Giriş yapın veya kayıt olun`,
    });

    return {
      userStore,
      loginForm,
      registerForm,
      birthdayFormat,
      rules,
      loginFormLoading,
      registerFormLoading,
    };
  },

  methods: {
    /**
     * Kullanıcı girişi gerekleştir
     */
    userLogin() {
      const { email, password, session } = this.loginForm;
      this.loginFormLoading = true;
      this.userStore
        .login({ email, password, session })
        .then((res) => {
          if (!res.status._200_) {
            this.$q.notify({
              color: 'negative',
              message: res.data.errMessage,
              position: 'bottom',
              icon: 'error',
            });

            this.loginFormLoading = false;
          } else {
            window.location.replace('/');
          }
        })
        .catch(() => {
          this.loginFormLoading = false;
        });
    },
    /**
     * Kullanıcı kaydı gerçekleştir
     */
    registerUser() {
      if (this.registerForm.userAgreement !== true) {
        this.$q.notify({
          color: 'negative',
          message: 'Kullanıcı sözleşmesini kabul etmeniz gerekmektedir.',
          position: 'bottom',
          icon: 'error',
        });
        return;
      }

      if (this.registerForm.gdprAgreement !== true) {
        this.$q.notify({
          color: 'negative',
          message: 'KVKK sözleşmesini kabul etmeniz gerekmektedir.',
          position: 'bottom',
          icon: 'error',
        });
        return;
      }

      if (this.registerForm.kvkkInformationAgreement !== true) {
        this.$q.notify({
          color: 'negative',
          message: 'KVKK bilgi paylaşımını kabul etmeniz gerekmektedir.',
          position: 'bottom',
          icon: 'error',
        });
        return;
      }

      this.registerFormLoading = true;

      const { nameSurname, email, password, passwordAgain, birthday, userAgreement } = this.registerForm;
      this.userStore
        .register({
          nameSurname,
          email,
          password,
          passwordAgain,
          birthday,
          userAgreement,
        })
        .then(({ status, message }) => {
          if (status._200_) {
            this.$q.notify({
              color: 'green',
              message: 'Kayıt işleminiz başarıyla tamamlandı. Giriş yapabilirsiniz.',
              icon: 'check',
            });
            window.location.replace('/');
          } else {
            this.error(message || 'Kayıt işlemi sırasında bir hata oluştu. Lütfen tekrar deneyiniz.');
          }
          this.registerFormLoading = false;
        })
        .catch(() => {
          this.registerFormLoading = false;
        });
    },
    openDate() {
      this.$refs.qDateProxy.show();
    },
    formatDate(date) {
      console.log(date);
      if (!date) return null;

      const [year, month, day] = date.split('-');
      return `${day}-${month}-${year}`;
    },
    error(message) {
      this.$q.notify({
        color: 'negative',
        message: message,
        icon: 'error',
      });
    },
  },
});
</script>

<template>
  <div class="container">
    <div class="row">
      <div class="col-xs-12 q-mt-md q-px-lg q-mb-sm">
        <h2 class="text-center text-h4 text-weight-light q-mb-lg">
          <q-icon name="touch_app" color="primary" />
          Sistemimize
          <span class="text-primary text-weight-medium">giriş yapın</span> veya
          <span class="text-primary text-weight-medium">kayıt olun</span>
        </h2>
        <q-separator />
      </div>
      <div class="col-xs-12 col-md-6 q-pa-lg">
        <q-card class="q-pa-md">
          <div class="giris-kayit-box q-mb-xl">
            <h2 class="text-h6 text-weight-bold text-primary q-mb-xs">
              <q-icon name="login" size="1.75rem" class="q-mr-sm"></q-icon>
              Giriş Yap
            </h2>
            <q-separator class="q-mb-sm" />
            <p class="text-caption text-grey-7">Giriş yapmak için eposta adresiniz ve şifrenizi giriniz</p>
          </div>
          <q-form @submit="userLogin" autocomplete="on" class="q-gutter-md">
            <q-input
              filled
              v-model="loginForm.email"
              label="E-Posta adresiniz"
              type="email"
              hint="Lütfen sistemde kayıtlı eposta adresinizi giriniz"
              lazy-rules
              :rules="[(val) => (val && val.length > 0) || 'E-Posta adresiniz zorunludur']"
              inputmode="email"
              autocomplete="email"
            />
            <q-input
              filled
              type="password"
              v-model="loginForm.password"
              label="Şifreniz"
              lazy-rules
              :rules="[(val) => (val !== null && val !== '') || 'Lütfen şifrenizi girin', (val) => val.length > 7 || 'Şifreniz en az 8 haneli olmalıdır']"
              autocomplete="current-password"
            />

            <div class="text-center">
              <q-btn label="Giriş Yap" icon="login" class="q-mb-sm q-px-xl" rounded type="submit" color="primary" :loading="loginFormLoading" />
            </div>
          </q-form>
        </q-card>
      </div>
      <div class="col-xs-12 col-md-6 q-pa-lg">
        <q-card class="q-pa-md">
          <div class="giris-kayit-box q-mb-xl">
            <h2 class="text-h6 text-weight-bold text-primary q-mb-xs">
              <q-icon name="how_to_reg" size="1.75rem" class="q-mr-sm"></q-icon>
              Kayıt Ol
            </h2>
            <q-separator class="q-mb-sm" />
            <p class="text-caption text-grey-7">Kayıt olmak için bilgilerinizi giriniz</p>
          </div>
          <q-form @submit="registerUser" autocomplete="on" class="q-gutter-md">
            <q-input
              name="register-username"
              filled
              v-model="registerForm.nameSurname"
              label="İsim Soyisim"
              hint="Lütfen adınızı ve soyadınızı giriniz"
              lazy-rules
              autocomplete="name"
              :rules="[(val) => (val && val.length > 0) || 'İsim soyisim zorunludur']"
            />
            <q-input
              name="register-email"
              filled
              v-model="registerForm.email"
              type="email"
              inputmode="email"
              label="E-Posta adresiniz"
              hint="Lütfen eposta adresinizi giriniz"
              lazy-rules
              :rules="[(val) => (val && val.length > 0) || 'E-Posta adresiniz zorunludur']"
              autocomplete="email"
            />
            <q-input
              name="register-password"
              filled
              type="password"
              v-model="registerForm.password"
              label="Şifreniz"
              hint="Lütfen bir en az 8 karakter olmak üzere bir şifre belirleyiniz"
              lazy-rules
              :rules="[(val) => (val !== null && val !== '') || 'Şifre alanı zorunludur', (val) => val.length > 7 || 'Şifreniz en az 8 haneli olmalıdır']"
              autocomplete="new-password"
            />
            <q-input
              name="register-password-again"
              filled
              type="password"
              v-model="registerForm.passwordAgain"
              label="Şifreniz Tekrar"
              hint="Lütfen şifrenizi tekrar giriniz"
              lazy-rules
              :rules="[
                (val) => (val !== null && val !== '') || 'Lütfen doğrulamak için şifrenizi tekrar giriniz',
                (val) => val.length > 7 || 'Şifreniz en az 8 haneli olmalıdır',
              ]"
              autocomplete="new-password"
            />
            <q-input
              name="register-birthday"
              filled
              v-model="birthdayFormat"
              label="Doğum tarihiniz"
              hint="Lütfen doğum tarihinizi belirtiniz"
              mask="##.##.####"
              :rules="[rules.dateRule]"
              @click="openDate"
              autocomplete="bday"
            >
              <template v-slot:append>
                <q-icon name="event" ref="dateIcon" class="cursor-pointer">
                  <q-popup-proxy ref="qDateProxy" transition-show="scale" transition-hide="scale">
                    <q-date v-model="registerForm.birthday" mask="YYYY-MM-DD" @update:modelValue="birthdayFormat = formatDate(registerForm.birthday)">
                      <div class="row items-center justify-end">
                        <q-btn v-close-popup label="Kapat" color="red" flat />
                      </div>
                    </q-date>
                  </q-popup-proxy>
                </q-icon>
              </template>
            </q-input>
            <div>
              <div class="flex items-center no-wrap">
                <q-toggle v-model="registerForm.userAgreement" color="green"> </q-toggle>
                <div>
                  <user-agreements toggle-accept @accept="registerForm.userAgreement = true">
                    <template #activator="{ toggleDialog }">
                      <basic-link href="#" @click="toggleDialog">Kullanıcı sözleşmesi</basic-link>
                    </template>
                  </user-agreements>
                  'ni okudum ve kabul ediyorum
                </div>
              </div>
              <div class="flex items-center no-wrap">
                <q-toggle v-model="registerForm.gdprAgreement" color="green" class="q-mt-none"> </q-toggle>
                <div>
                  <k-v-k-k-agreements toggle-accept @accept="registerForm.gdprAgreement = true">
                    <template #activator="{ toggleDialog }">
                      <basic-link href="#" @click="toggleDialog">KVKK Aydınlatma Metni</basic-link>
                    </template>
                  </k-v-k-k-agreements>
                  'ni okudum ve kabul ediyorum
                </div>
              </div>
              <div class="flex items-center no-wrap">
                <q-toggle v-model="registerForm.kvkkInformationAgreement" color="green" class="q-mt-none"> </q-toggle>
                <div>
                  Kişisel verilerimin yurt dışında bulunan sunucularda işlenmesine ve saklanmasına açık rıza veriyorum.
                  <k-v-k-k-information toggle-accept @accept="registerForm.kvkkInformationAgreement = true">
                    <template #activator="{ toggleDialog }">
                      <basic-link href="#" @click="toggleDialog">Detaylı Bilgi</basic-link>
                    </template>
                  </k-v-k-k-information>
                </div>
              </div>
            </div>
            <div class="text-center">
              <q-btn label="Kayıt Ol" icon="how_to_reg" rounded type="submit" class="q-px-xl" color="primary" :loading="registerFormLoading" />
            </div>
            <input type="hidden" name="form-type" value="register" />
          </q-form>
        </q-card>
      </div>
    </div>
  </div>
</template>

<style scoped></style>
